import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeQuestion: 0,
  results: [],
};

export const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {
    next: (state, action) => {
      state.results = [...state.results, action.payload];
      state.activeQuestion += 1;
    },
  },
});

// Action creators are generated for each case reducer function
export const { next } = questionSlice.actions;

export default questionSlice.reducer;
